import React from "react";
import ReportItemEntityListRow from "../Entities/ReportItemEntityListRow";

export default function AnsweringTendencyEntity({ entity, children }) {
  return (
    <div className="report-scheme-report-item-row">
      <ReportItemEntityListRow entity={entity} itemName="Cevaplama Yatkınlığı" />
      {children && children}
    </div>
  );
}